<template>
  <div class="d-flex flex-column">
    <b-card style="width:100%">
      <h4>Last Available Date</h4>
      <div class="d-flex mt-1">
        <b-overlay
          variant="white"
          spinner-variant="primary"
          blur="0"
          opacity=".75"
          rounded="sm"
          :show="loadingDriverStatusHistory"
        />
        <span
          v-if="!loadingDriverStatusHistory"
          class="pl-1"
        >{{ driverStatusHistory.length != 0 ? driverStatusHistory : 'There is no data.' }}</span>
      </div>
      <hr>
      <b-overlay
        variant="white"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
        :show="loadingDriverStaus"
      >
        <div class="d-flex flex-column">
          <div class="d-flex align-items-start-flex justify-content-between">
            <div class="d-flex align-items-baseline">
              <b-form-group>
                <b-form-radio-group
                  v-model="selectedOption"
                  :options="optionsKeys"
                  value-field="value"
                  text-field="label"
                />
              </b-form-group>
            </div>
            <b-button
              class="cursor-pointer"
              variant="outline-primary"
              size="sm"
              @click="fetchDriverStatus"
            >
              <span>Search</span>
            </b-button>
          </div>
          <div
            v-if="selectedOption === 'currentMonth'"
            class="d-flex py-1"
          >
            <b-form-datepicker
              v-model="firstDay"
              placeholder="Date"
              hide-header
              size="sm"
              :min="min"
              :max="max"
              value-as-date
              label-help=""
              class="mr-1"
            />
            <b-button
              v-if="firstDay"
              size="sm"
              variant="primary"
              class="btn-tour-next"
              @click="resetDates"
            >
              <feather-icon
                icon="XIcon"
                size="12"
              />
            </b-button>
          </div>
          <div class="d-flex flex-column">
            <div
              v-for="(item, ix) in driverStatistics"
              :key="ix"
              class="d-flex"
            >
              <h5 style="margin-right: 24px; width: 200px;">
                {{ item.title }}
              </h5>
              <span>{{ item.value }}</span>
            </div>
          </div>
        </div>
      </b-overlay>
    </b-card>
    <div class="d-flex justify-content-between">
      <b-card style="width:50%">
        <b-card-title>
          <h2>Trips statistics</h2>
        </b-card-title>
        <table class="mt-3 w-100">
          <tr>
            <th class="pb-50">
              <span class="font-weight-bold">Last completed trip</span>
            </th>
            <td class="pb-50">
              {{ driverData.lastCompleted ? driverData.lastCompleted : 'Not Available' }}
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <span class="font-weight-bold">Total trips</span>
            </th>
            <td class="pb-50">
              {{ totalTrips }}
            </td>
          </tr>
        </table>
      </b-card>

      <b-card style="width:49%">
        <b-card-title>
          <h2>Dispatch statistics </h2>
        </b-card-title>
        <b-overlay
          variant="white"
          spinner-variant="primary"
          blur="0"
          opacity=".75"
          rounded="sm"
          :show="showStatistics"
        >
          <table
            v-if="dispatchStatisticsValues.length"
            class="mt-2 w-100"
          >
            <tr
              v-for="(el, ind) in dispatchStatisticsValues"
              :key="ind"
            >
              <th class="pb-50">
                <span class="font-weight-bold">{{ el.name }} </span>
              </th>
              <td class="pb-50">
                {{ el.value ? el.value : '_' }}
              </td>
            </tr>

          </table>
          <p
            v-else
            class="text-center"
          >
            No matching statistics found
          </p>
        </b-overlay>
      </b-card>

    </div>
  </div>
</template>

<script>
import {
  BCard, BCardTitle, BOverlay, BFormGroup, BFormRadioGroup, BButton, BFormDatepicker,
} from 'bootstrap-vue'
import { computed, ref, watch } from '@vue/composition-api'
import { errorNotification } from '@/utils/toast-notifications'

function sumTimeStrings(time1, time2) {
  const [hours1, minutes1] = time1.split(':').map(Number)
  const [hours2, minutes2] = time2.split(':').map(Number)

  // Convert both times to total minutes
  const totalMinutes1 = hours1 * 60 + minutes1
  const totalMinutes2 = hours2 * 60 + minutes2

  // Add the total minutes
  const totalMinutes = totalMinutes1 + totalMinutes2

  // Convert back to hours and minutes
  const totalHours = Math.floor(totalMinutes / 60)
  const remainingMinutes = totalMinutes % 60

  // Format as HH:MM
  return `${totalHours}:${remainingMinutes.toString().padStart(2, '0')}`
}

export default {
  components: {
    BCard,
    BCardTitle,
    BOverlay,
    BFormGroup,
    BFormRadioGroup,
    BButton,
    BFormDatepicker,
  },
  props: {
    driverData: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props, ctx) {
    const totalTrips = computed(() => ctx.root.$store.getters['driverUsersTrips/getTotalTrips'])
    const dispatchStatisticsValues = ref([])
    const showStatistics = ref(false)
    const dispatchStatistics = async () => {
      try {
        showStatistics.value = true
        const res = (await ctx.root.$store.dispatch('driverView/fetchDispatchStatistics', props.driverData.externalId)).data.data
        dispatchStatisticsValues.value = [
          {
            name: 'Total recieved',
            value: res?.result?.recieved,
          },
          {
            name: 'Total accepted',
            value: res?.result?.accepted,
          },
          {
            name: 'Total rejected',
            value: res?.result?.rejected,
          },
          {
            name: 'Total auto rejected',
            value: res?.result?.auto_reject,
          },
          {
            name: 'Total canceled',
            value: res?.result?.canceled,
          },
        ]
      } catch (error) {
        console.log(error)
      } finally {
        showStatistics.value = false
      }
    }
    const driverStatusHistory = ref('')
    const optionsKeys = [
      {
        value: 'today',
        label: 'Today',
      },
      {
        value: 'yesterday',
        label: 'Yesterday',
      },
      {
        value: 'lastMonth',
        label: 'Last Month',
      },
      {
        value: 'currentMonth',
        label: 'Current Month',
      },
    ]
    const firstDay = ref('')

    const selectedOption = ref('today')
    watch([selectedOption], () => {
      firstDay.value = ''
    })
    const driverExternalId = ctx.root.$route.query.externalId
    const driverID = ctx.root.$route.params.id
    const loadingDriverStaus = ref(false)
    const loadingDriverStatusHistory = ref(false)
    const driverStatistics = ref([])
    const fetchDriverStatusHistory = async () => {
      try {
        loadingDriverStatusHistory.value = true
        const res = await ctx.root.$store.dispatch('driverView/fetchDriverStatusHistory', driverExternalId)
        const temp = res?.data.data.lastPath.split('.')[0]
        driverStatusHistory.value = `${temp.split('/')[1]}/${temp.split('/')[2]}`
      } catch (error) {
        console.log(error)
      } finally {
        loadingDriverStatusHistory.value = false
      }
    }
    const fetchDriverStatus = async () => {
      loadingDriverStaus.value = true
      let activeDate = null
      const now = new Date()
      try {
        if (selectedOption.value === 'today') {
          activeDate = new Date()
          activeDate.setHours(0, 0, 0, 0)
        } else if (selectedOption.value === 'yesterday') {
          activeDate = new Date(now)
          activeDate.setHours(0, 0, 0, 0)
          activeDate.setDate(now.getDate() - 1)
        } else if (selectedOption.value === 'lastMonth') {
          activeDate = new Date(now)
          activeDate.setHours(0, 0, 0, 0)
          activeDate.setMonth(now.getMonth() - 1)
          activeDate.setDate(1)
        } else if (selectedOption.value === 'currentMonth') {
          if (firstDay.value) {
            activeDate = new Date(firstDay.value)
          } else {
            activeDate = new Date()
            activeDate.setHours(0, 0, 0, 0)
            activeDate.setDate(1)
          }
        }
        const formattedDate = `${activeDate.getFullYear()}-${String(activeDate.getMonth() + 1).padStart(2, '0')}-${String(activeDate.getDate()).padStart(2, '0')}`
        const res2 = await ctx.root.$store.dispatch('driverView/fetchDriverStateStatistics', {
          id: driverID,
          from: formattedDate,
        })

        let AVAILABLE_VAL
        let OCCUPIED_VAL
        let TOTAL_VAL
        let UNAVAILABLE_VAL

        if (selectedOption.value === 'yesterday') {
          const { days } = res2.data.data.data
          const daysObjKeys = Object.keys(days)
          if (daysObjKeys.length) {
            const firstKey = daysObjKeys[0]
            const { AVAILABLE, OCCUPIED, UNAVAILABLE } = days[firstKey]
            AVAILABLE_VAL = AVAILABLE
            OCCUPIED_VAL = OCCUPIED
            UNAVAILABLE_VAL = UNAVAILABLE
            TOTAL_VAL = sumTimeStrings(AVAILABLE, OCCUPIED)
          } else {
            AVAILABLE_VAL = '00:00'
            OCCUPIED_VAL = '00:00'
            UNAVAILABLE_VAL = '00:00'
            TOTAL_VAL = '00:00'
          }
        } else {
          const { AVAILABLE, OCCUPIED, UNAVAILABLE } = res2.data.data.data.statistics
          AVAILABLE_VAL = AVAILABLE
          OCCUPIED_VAL = OCCUPIED
          UNAVAILABLE_VAL = UNAVAILABLE
          TOTAL_VAL = sumTimeStrings(AVAILABLE, OCCUPIED)
        }

        driverStatistics.value = [
          {
            title: 'Available Hours',
            value: res2.data.data.data.statistics ? `${AVAILABLE_VAL.split(':')[0]} hours ${AVAILABLE_VAL.split(':')[1]} minutes` : 'There is no data.',
          },
          {
            title: 'Unavailable Hours',
            value: res2.data.data.data.statistics ? `${UNAVAILABLE_VAL.split(':')[0]} hours ${UNAVAILABLE_VAL.split(':')[1]} minutes` : 'There is no data.',
          },
          {
            title: 'Occupied Hours',
            value: res2.data.data.data.statistics ? `${OCCUPIED_VAL.split(':')[0]} hours ${OCCUPIED_VAL.split(':')[1]} minutes` : 'There is no data.',
          },
          {
            title: 'Total Available Hours',
            value: res2.data.data.data.statistics ? `${TOTAL_VAL.split(':')[0]} hours ${TOTAL_VAL.split(':')[1]} minutes` : 'There is no data.',
          },
        ]
      } catch (error) {
        console.log(error)
        const msg = error?.response?.data?.message[0]
        errorNotification(msg)
      } finally {
        loadingDriverStaus.value = false
      }
    }

    const date = new Date()
    const min = new Date(date.getFullYear(), date.getMonth(), 1)
    const max = new Date(date.getFullYear(), date.getMonth() + 1, 0)

    const resetDates = () => {
      firstDay.value = ''
    }
    dispatchStatistics()
    fetchDriverStatus()
    fetchDriverStatusHistory()
    return {
      totalTrips,
      dispatchStatisticsValues,
      showStatistics,
      driverStatusHistory,
      fetchDriverStatus,
      loadingDriverStaus,
      loadingDriverStatusHistory,
      driverStatistics,
      optionsKeys,
      min,
      max,
      firstDay,
      selectedOption,
      resetDates,
    }
  },

}
</script>

<style></style>
